function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import { MaestroLogo } from "../../logos/MaestroLogo";
/**
 * @deprecated prefer Michelin branding
 */

export var getLogoMaestro = function getLogoMaestro(type) {
  var baseLogoDefinition = {
    light: MaestroLogo.LIGHT,
    dark: MaestroLogo.DARK
  };

  switch (type) {
    case 'dark':
      return _extends({}, baseLogoDefinition, {
        primary: MaestroLogo.DARK
      });

    case 'light':
    default:
      return _extends({}, baseLogoDefinition, {
        primary: MaestroLogo.LIGHT
      });
  }
};